import { Box, Separator, Stack, Text } from "@chakra-ui/react";

const MediaVideo = ({ dataDevelopment }) => {
    return (
        <Stack>
            {dataDevelopment?.media_props?.youtube_url && (
                <Box bg="white" rounded="md">
                    <Text fontWeight={700} fontSize="md" mt="3vh" mb={4}>
                        Video
                    </Text>
                    <Box borderRadius="md" overflow="hidden" mb="5vh">
                        <iframe
                            src={
                                dataDevelopment?.media_props?.youtube_url
                                    ?.replaceAll(
                                        "https://youtu.be/",
                                        "https://www.youtube.com/embed/"
                                    )
                                    .replaceAll(
                                        "https://www.youtube.com/watch?v=",
                                        "https://www.youtube.com/embed/"
                                    )
                                    .split("&")[0]
                            }
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                            width="100%"
                            height="400"
                        />
                    </Box>
                    <Separator borderColor="#B1B1B1" />
                </Box>
            )}
        </Stack>
    );
};

export default MediaVideo;
